import c from '@/styles/Checkbox';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface CheckboxLabelProps extends ComponentProps<'label'> {
  colors?: ClassNameProp<'default' | 'alternative'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const CheckboxLabelComponent: Component<CheckboxLabelProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('label_colors', colors ?? variant, 'default');
  const sizeClassName = getPropStyles('label_size', size ?? variant, 'default');
  const variantClassName = getPropStyles('label_variant', variant, 'default');
  const componentClassName = cn('cursor-pointer', sizeClassName, variantClassName, colorsClassName, className);

  return (
    <label className={componentClassName} {...props}>
      {children}
    </label>
  );
};
